import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ALL_ROUTES from "./util/Route";
import { isLogin } from "./util/functions";
import useHttp from "./hooks/use-http";
import CONSTANTS from "./util/constant/CONSTANTS";
function App() {
  const [admindetails, setAdmindetails] = useState({})
  const api = useHttp()
  useEffect(() => {
    // console.log(!isLogin());
    if (!isLogin()) {
      return;
    }

    const GET_MY_PROFILE_API = { ...CONSTANTS.API.getMe }

    api.sendRequest(GET_MY_PROFILE_API, (res) => {
      setAdmindetails(res?.data)
    })


  }, [isLogin])


  const router = createBrowserRouter(ALL_ROUTES({ admindetails }));
  return <RouterProvider router={router} />;
}

export default App;
